// Module
var code = `<nav class="sidenav">
  <section class="sidenav-section">
    <div class="sidenav-section__header">Dashboard</div>
    <div class="sidenav-section__entries">
      <button permissions="ACTIONS_READ"
              class="sidenav__tab sidenav__tab--actions"
              ng-class="setActiveTabClass('dashboard/actions')"
              ng-click="selectTab('dashboard/actions')">
        <i class="icon-check"></i>Actions
        <span ng-show="\$ctrl.availableTasks > 0"
              class="badge badge-important sidenav-actions-counter">
          {{\$ctrl.availableTasks}}
        </span>
      </button>
      <button permissions="GL_MISC_TRANSACTION_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/miscellaneous-transactions')"
              ng-click="selectTab('dashboard/miscellaneous-transactions')">
        <i class="icon-retweet"></i>Transactions</button>
      <button permissions="BRANCH_HISTORY_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/history/miscellaneous-transactions')"
              ng-click="selectTab('dashboard/history/miscellaneous-transactions')">
        <i class="icon-th-list"></i>History</button>
      <button permissions="LOAN_COLLECTIONS_READ"
              command-access="PayLoanByCashBatch"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/collections')"
              ng-click="selectTab('dashboard/collections')">
        <i class="icon icon-shopping-cart"></i>Collections</button>
      <button permissions="HEALTH_CHECK_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/health-check')"
              ng-click="selectTab('dashboard/health-check')">
        <i class="icon icon-plus"></i>Health Check</button>
      <button permissions="LOOKUP_CUSTOMER_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/lookup-customer')"
              ng-click="selectTab('dashboard/lookup-customer')">
          <i class="icon-search"></i>Lookup Customer</button>
      <button permissions="LOOKUP_CUSTOMER_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/lookup-group')"
              ng-click="selectTab('dashboard/lookup-group')">
        <i class="icon-search"></i>Lookup Group</button>
      <button permissions="LOOKUP_CUSTOMER_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('dashboard/lookup-center')"
              ng-click="selectTab('dashboard/lookup-center')">
        <i class="icon-search"></i>Lookup Center</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Inventory</div>
    <div class="sidenav-section__entries">
      <button permissions="CHK_CHECK_INVENTORY_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('inventory/checks')"
              ng-click="selectTab('inventory/checks')">
        <i class="icon-dollar"></i>&nbsp;Checks</button>
      <button permissions="CHK_CHECK_INVENTORY_READ"
              command-access="BatchValidateInwardCheck,BatchClearInwardCheck"
              class="sidenav__tab"
              ng-class="setActiveTabClass('inventory/batch-clearing')"
              ng-click="selectTab('inventory/batch-clearing')">
        <i class="icon-dollar"></i>&nbsp;Batch clearing</button>
      <button permissions="CHK_CHECK_INVENTORY_READ"
              command-access="PayLoanByPDCBatch"
              class="sidenav__tab"
              ng-class="setActiveTabClass('inventory/batch-pdc-payment')"
              ng-click="selectTab('inventory/batch-pdc-payment')">
        <i class="icon-dollar"></i>&nbsp;Batch PDC payment</button>
      <!-- TODO = assign dedicated permission here  -->
      <button permissions="CHK_CHECK_INVENTORY_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('inventory/stop-orders')"
              ng-click="selectTab('inventory/stop-orders')">
        <i class="icon-stop"></i>&nbsp;Stop orders</button>
    </div>
  </section>

  <section class="sidenav-section" ng-show="customerContextService.customerId" data-unobserved="true">
    <div class="sidenav-section__header">Customer
      <i ng-click="refreshCustomer(\$event, customerCache)"
         id="customer_refresh_icon" class="icon-refresh">
      </i><i ng-click="closeCustomer(\$event, customerCache)"
         id="customer_close_icon"
         class="icon-remove"></i></div>
    <div class="sidenav-section__entries">
      <button permissions="CST_DEPOSIT_ACCOUNT_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/accounts')"
              ng-click="selectCustomerTab('customer/:customerId/accounts')">
        <i class="icon-th-list"></i>Deposit Accounts</button>
      <button permissions="CST_TERM_DEPOSIT_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/term-deposits')"
              ng-click="selectCustomerTab('customer/:customerId/term-deposits')">
        <i class="icon-calendar"></i>Term Deposits</button>
      <button permissions="CST_CREDIT_LINE_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/credit-lines')"
              ng-click="selectCustomerTab('customer/:customerId/credit-lines')">
        <i class="icon-time"></i>Credit Lines</button>
      <button permissions="CST_LOANS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/loans')"
              ng-click="selectCustomerTab('customer/:customerId/loans')">
        <i class="icon-time"></i>Loans</button>
      <button permissions="CST_STATEMENTS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/statements')"
              ng-click="selectCustomerTab('customer/:customerId/statements')">
        <i class="icon-file"></i>Statements</button>
      <button ng-if="\$ctrl.shouldDisplayRiskProfiling"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/risk-profile')"
              ng-click="selectCustomerTab('customer/:customerId/risk-profile')">
        <i class="icon-user"></i>Risk profile</button>
      <button permissions="CST_CIF_READ, CST_ALL_BRANCHES_ACCESS"
              permission-context="{customerId: customerCache.loadedCustomerId}"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/profile')"
              ng-click="selectCustomerTab('customer/:customerId/profile')">
        <i class="icon-user"></i>Profile
        <i ng-if="customerContextService.hasInvalidData" class="invalid-profile icon icon-warning-sign"></i>
      </button>
      <button permissions="CST_CIF_READ"
              permission-context="{customerId: customerCache.loadedCustomerId}"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/collaterals')"
              ng-click="selectCustomerTab('customer/:customerId/collaterals')">
        <i class="icon-file-text-alt"></i>Collaterals
      </button>
      <!--Cocree-->
      <button ng-if="\$ctrl.systemPropertyService.getProperty('COCREE_ENABLED') === 'TRUE'"
              permissions="CST_COCREE_READ"
              permission-context="{customerId: customerCache.loadedCustomerId}"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/cocree')"
              ng-click="selectCustomerTab('customer/:customerId/cocree')">
        <i class="icon-file-text-alt"></i>COCREE
      </button>
    </div>
  </section>

  <section class="sidenav-section" ng-show="groupCustomerCache.loadedCustomerId != null" data-unobserved="true">
    <div class="sidenav-section__header">Group
      <i ng-click="refreshCustomer(\$event, groupCustomerCache)"
         class="icon-refresh"></i>
      <i ng-click="closeCustomer(\$event, groupCustomerCache)"
         class="icon-remove"></i>
    </div>
    <div class="sidenav-section__entries">
      <button permissions="CST_LOANS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/group-loans')"
              ng-click="selectGroupCustomerTab('customer/:customerId/group-loans')">
        <i class="icon-time"></i>Loans</button>
      <button permissions="CST_CIF_READ, CST_ALL_BRANCHES_ACCESS"
              permission-context="{customerId: groupCustomerCache.loadedCustomerId}"
              class="sidenav__tab"
              ng-class="setActiveTabClass('customer/[^/]+/group-profile')"
              ng-click="selectGroupCustomerTab('customer/:customerId/group-profile')">
        <i class="icon-user"></i>Profile</button>
    </div>
  </section>

  <section class="sidenav-section" ng-if="\$ctrl.centerService.contextCenterId != null" data-unobserved="true">
    <div class="sidenav-section__header">Center
      <i ng-click="\$ctrl.refreshCenterContext(\$event)"
         class="icon-refresh"></i>
      <i ng-click="\$ctrl.closeCenterContext(\$event)"
         class="icon-remove"></i>
    </div>
    <div class="sidenav-section__entries">
      <button class="sidenav__tab"
              ng-class="setActiveTabClass('center/[^/]+/groups/?')"
              ng-click="selectTab('center/' + \$ctrl.centerService.contextCenterId + '/groups')">
        <i class="icon-group"></i>Groups
      </button>
    </div>
    <div class="sidenav-section__entries">
      <button class="sidenav__tab"
              ng-class="setActiveTabClass('center/[^/]+/(details|edit)/?')"
              ng-click="selectTab('center/' + \$ctrl.centerService.contextCenterId + '/details')">
        <i class="icon-info-sign"></i>Details
      </button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Agent Banking</div>
    <div class="sidenav-section__entries">
      <button permissions="AGENT_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('agent-banking/application')"
              ng-click="selectTab('agent-banking/application')">
        <i class="icon-male"></i>Application</button>
      <button permissions="AGENT_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('agent-banking/agents')"
              ng-click="selectTab('agent-banking/agents')">
        <i class="icon-male"></i>Agents</button>
      <button permissions="REPORTS_AGENT"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/agent-banking')"
              ng-click="selectTab('report/agent-banking')">
        <i class="icon-th-list"></i>Reports</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Check Preparation</div>
    <div class="sidenav-section__entries">
      <button permissions="CHK_CHECK_INVENTORY_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('check-preparation/check-management/depository-accounts')"
              ng-click="selectTab('check-preparation/check-management/depository-accounts')">
        <i class="icon-dollar"></i>Check Management</button>
      <button permissions="CHECK_PREPARATION_ASSIGNMENT_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('check-preparation/assignment')"
              ng-click="selectTab('/check-preparation/assignment')">
        <i class="icon-th-list"></i>Assignment</button>
      <button permissions="CHECK_PREPARATION_ASSIGNED_CHECKS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('check-preparation/assigned-checks')"
              ng-click="selectTab('/check-preparation/assigned-checks')">
        <i class="icon-th-list"></i>Assigned Checks</button>
      <button permissions="CHECK_PREPARATION_OUTGOING_CHECKS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('check-preparation/outgoing-checks')"
              ng-click="selectTab('/check-preparation/outgoing-checks')">
        <i class="icon-th-list"></i>Outgoing Checks</button>
      <button permissions="CHECK_PREPARATION_HISTORY_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('check-preparation/history')"
              ng-click="selectTab('/check-preparation/history')">
        <i class="icon-backward"></i>History</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Batch</div>
    <div class="sidenav-section__entries">
      <button command-access="BatchUploadAcquirers"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/atm')"
              ng-click="selectTab('batch/atm')">
        <i class="icon-money"></i>ATM</button>
      <button permissions="CST_DEPOSIT_ACCOUNT_WRITE"
              command-access="AccountBatchMemo"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/memo')"
              ng-click="selectTab('batch/memo')">
        <i class="icon-th-list"></i>Memo</button>
      <button command-access="PayDepEdLoanFileBatch"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/deped-loans')"
              ng-click="selectTab('batch/deped-loans')">
        <i class="icon-th-list"></i>DepEd Loans</button>
      <button command-access="SSSPensionFileUpload"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/sss-pension')"
              ng-click="selectTab('batch/sss-pension')">
        <i class="icon-th-list"></i>SSS Pension</button>
      <button command-access="PayLoanByBatch,PreterminateLoanByBatch"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/loans')"
              ng-click="selectTab('batch/loans')">
        <i class="icon-th-list"></i>Loans</button>
      <button permissions="BATCH_REMITTANCE_UPLOAD_VIEW"
              class="sidenav__tab"
              ng-class="setActiveTabClass('batch/remittance')"
              ng-click="selectTab('batch/remittance')">
        <i class="icon-th-list"></i>Remittance</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Reports</div>
    <div class="sidenav-section__entries">
      <button permissions="REPORTS_GL"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/general-ledger')"
              ng-click="selectTab('report/general-ledger')">
        <i class="icon-th-list"></i>General Ledger</button>
      <button permissions="REPORTS_ACCOUNTS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/deposit-accounts')"
              ng-click="selectTab('report/deposit-accounts')">
        <i class="icon-th-list"></i>Deposit Accounts</button>
      <button permissions="REPORTS_TERM_DEPOSITS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/term-deposits')"
              ng-click="selectTab('report/term-deposits')">
        <i class="icon-th-list"></i>Term Deposits</button>
      <button permissions="REPORTS_LOANS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/loans')"
              ng-click="selectTab('report/loans')">
        <i class="icon-th-list"></i>Loans</button>
      <button permissions="REPORTS_REGULATORY"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/regulatory')"
              ng-click="selectTab('report/regulatory')">
        <i class="icon-th-list"></i>Regulatory</button>
      <button permissions="CUSTOM_QUERY_ADMIN"
              class="sidenav__tab"
              ng-class="setActiveTabClass('custom-query')"
              ng-click="selectCustomerTab('custom-query')">
        <i class="icon-th-list"></i>Custom Query</button>
        <button permissions="CUSTOM_REPORT_ADMIN"
              class="sidenav__tab"
              ng-class="setActiveTabClass('custom-report')"
              ng-click="selectCustomerTab('custom-report')"
              ng-if="\$ctrl.hasReportToolEnabled == true">
        <i class="icon-th-list"></i>Custom Report</button>
      <button permissions="REPORTS_DYNAMIC"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/dynamic')"
              ng-click="selectTab('report/dynamic')">
        <i class="icon-th-list"></i>Dynamic Reports</button>
      <button permissions="REPORTS_SECURITY"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/security')"
              ng-click="selectTab('report/security')">
        <i class="icon-th-list"></i>Security Reports</button>
      <button permissions="REPORTS_MISCELLANEOUS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/other')"
              ng-click="selectTab('report/other')">
        <i class="icon-th-list"></i>Other</button>
      <button permissions="REPORTS_FILE_CONVERTER"
              class="sidenav__tab"
              ng-class="setActiveTabClass('report/converter')"
              ng-click="selectTab('report/converter')">
        <i class="icon-th-list"></i>Converter</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">General Ledger</div>
    <div class="sidenav-section__entries">
      <button permissions="GL_ACCOUNTS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('general-ledger/accounts')"
              ng-click="selectTab('general-ledger/accounts')">
        <i class="icon-th"></i>Accounts</button>
      <button permissions="GL_TRANSACTIONS_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('general-ledger/transactions')"
              ng-click="selectTab('general-ledger/transactions')">
        <i class="icon-retweet"></i>Tickets</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Products</div>
    <div class="sidenav-section__entries">
      <button permissions="DEPOSIT_ACCOUNT_TYPES_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/deposit-accounts')"
              ng-click="selectTab('admin/deposit-accounts')">
        <i class="icon-briefcase"></i>Deposit Accounts</button>
      <button permissions="TERM_DEPOSIT_TYPES_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/term-deposits')"
              ng-click="selectTab('admin/term-deposits')">
        <i class="icon-briefcase"></i>Term Deposits</button>
      <button permissions="LOAN_TYPES_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/loan-products')"
              ng-click="selectTab('admin/loan-products')">
        <i class="icon-usd"></i>&nbsp;Loans</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Compliance</div>
    <div class="sidenav-section__entries">
      <button permissions="RED_FLAG_DISPOSITION_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('compliance/red-flag-disposition')"
              ng-click="selectTab('compliance/red-flag-disposition')">
        <i class="icon-briefcase"></i>Red Flags Disposition</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Administration</div>
    <div class="sidenav-section__entries">
      <button permissions="MNG_BRANCH_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/organization')"
              ng-click="selectTab('admin/organization')">
        <i class="icon-user"></i>Organization</button>
      <button permissions="MNG_BRANCH_READ, REPORTS_GL"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/general-ledger')"
              ng-click="selectTab('admin/general-ledger')">
        <i class="icon-th-list"></i>General Ledger</button>
      <button permissions="MNG_BRANCH_READ, MNG_ATM_READ"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/atm-terminals')"
              ng-click="selectTab('admin/atm-terminals')">
        <i class="icon-money"></i>ATM Terminals</button>
      <button permissions="MNG_PRINTS_WRITE"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/prints')"
              ng-click="selectTab('admin/prints')">
        <i class="icon-briefcase"></i>Printing</button>
      <button permissions="MNG_ROLES"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/security')"
              ng-click="selectTab('admin/security')">
        <i class="icon-lock"></i>Security</button>
      <button permissions="MNG_ROLES"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/compliance')"
              ng-click="selectTab('admin/compliance')">
        <i class="icon-user"></i>Compliance</button>
      <button
              permissions="MNG_CUSTOMER_CUSTOM_FIELDS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/customer/custom-fields/groups/CUSTOMER')"
              ng-click="selectTab('admin/customer/custom-fields/groups/CUSTOMER')">
        <i class="icon-user"></i>Customer</button>
      <button permissions="MNG_READ_LOGGED_IN_USERS"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/logged-in')"
              ng-click="selectTab('admin/logged-in-users')">
        <i class="icon-user"></i>Logged In Users</button>
      <button command-access="UpdateReportConfiguration"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/report-configuration')"
              ng-click="selectTab('admin/report-configuration')">
        <i class="icon-th-list"></i>Report configuration</button>
      <button command-access="UpdateDynamicReport"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/dynamic-report')"
              ng-click="selectTab('admin/dynamic-report')">
        <i class="icon-th-list"></i>Report Mapping</button>
      <button ng-if="\$ctrl.systemPropertyService.getProperty('AUTOMATED_OFFICIAL_RECEIPTS_ENABLED') === 'TRUE'"
              command-access="CreateOfficialReceiptBooklets,AssignOfficialReceiptBooklet"
              class="sidenav__tab"
              ng-class="setActiveTabClass('admin/invoice-branches')"
              ng-click="selectTab('admin/invoice-branches')">
        <i class="icon-th-list"></i>Invoice</button>
    </div>
  </section>

  <section class="sidenav-section">
    <div class="sidenav-section__header">Support</div>
    <div class="sidenav-section__entries">
      <button permissions="SUPPORT"
              class="sidenav__tab"
              ng-class="setActiveTabClass('support')"
              ng-click="selectTab('support')">
        <i class="icon-wrench"></i>Misc support</button>
    </div>
    <div class="sidenav-section__entries">
      <a ng-href="{{ trustedSupportFormUrl }}" target="_blank" class="sidenav__tab">
        <i class="icon-external-link"></i>Contact support
      </a>
    </div>
  </section>

  <div class="sidenav__version-info">{{ \$ctrl.versionInfo }}</div>
</nav>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/menu/menu.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;